import { atLeastReader, isInvite, isOwner as hasOwnerPermission, } from '#pplx/frontend/components/utils/PrivacyUtils.js';
export function getSpaceMenuActionPermissions(space) {
    const permission = space.user_permission;
    const isOwner = hasOwnerPermission(permission);
    // Leaving requires accepted membership. INVITED_* grants `view` since
    // Phase 1d, so atLeastReader alone would offer "Leave" to someone who was
    // invited and never joined; they decline the invite instead.
    const isAcceptedMember = atLeastReader(permission) && !isInvite(permission);
    return [!isOwner && isAcceptedMember, isOwner];
}
//# sourceMappingURL=getSpaceMenuActionPermissions.js.map